import {usePanorama} from '@wix/yoshi-flow-editor'

export const createLogger = ({panoramaClient}: CreateLoggerParams) => {
  return {
    startInteraction: (interaction: Interaction) => {
      panoramaClient?.transaction?.(interaction).start()
    },
    finishInteraction: (interaction: Interaction) => {
      panoramaClient?.transaction?.(interaction).finish()
    },
  }
}

interface CreateLoggerParams {
  panoramaClient: ReturnType<typeof usePanorama>
}

export enum Interaction {
  CreateReservation = 'create-reservation',
  Checkout = 'checkout',
  LoadingTickets = 'loading-tickets',
  PaymentWidgetLoad = 'PAYMENT_WIDGET_LOAD',
}

export type Logger = ReturnType<typeof createLogger>
